import { SiteDashboardAttributes } from "~/api/Api";

import { DecodedWidgetConfig } from "./types/DecodedWidgetConfig.type";

// Grid is 6 columns wide (DASHBOARD_NUM_COLUMNS). Splits used here:
// 50/50 (3+3), 67/33 (4+2), and 100% (6). Bump the grid to 12 cols
// later if finer splits become important.
export const DEFAULT_DASHBOARD: SiteDashboardAttributes = {
  name: "Google Dashboard",
  properties: {
    widgets: [
      // ── Row 1: bar 50% │ cards 50% ────────────────────────────
      {
        id: "GA-total-organic-sessions-by-day",
        integration: "google_analytics",
        method: "property_report",
        metadata: {
          placement: { x: 0, y: 0, w: 3, h: 1 },
          title: "Total Organic Sessions By Day",
          viewType: "bar-chart",
        },
        // NOTE: ranges are injected at query time from the global date picker
        query: {
          dimensions: ["date"],
          metrics: ["sessions", "totalUsers"],
          orderBys: [
            {
              dimension: { dimensionName: "date" },
              desc: false,
            },
          ],
          organic: false,
        },
      },
      {
        id: "GSC-essential-seo-metrics",
        integration: "google_search_console",
        method: "search_analytics",
        metadata: {
          placement: { x: 3, y: 0, w: 3, h: 1 },
          title:
            "Essential SEO metrics for tracking organic search performance",
          viewType: "cards",
        },
        query: {},
      },

      // ── Row 2: line ~67% │ cards ~33% ─────────────────────────
      {
        id: "GA-content-engagement-trends",
        integration: "google_analytics",
        method: "property_report",
        metadata: {
          placement: { x: 0, y: 1, w: 4, h: 1 },
          title: "Content Engagement Trends",
          viewType: "line-chart",
        },
        query: {
          dimensions: ["date"],
          metrics: ["screenPageViews", "totalUsers"],
          orderBys: [
            {
              dimension: { dimensionName: "date" },
              desc: false,
            },
          ],
          organic: false,
        },
      },
      {
        id: "GA-total-organic-sessions",
        integration: "google_analytics",
        method: "property_report",
        metadata: {
          placement: { x: 4, y: 1, w: 2, h: 1 },
          title: "Total Organic Sessions",
          viewType: "cards",
        },
        query: {
          metrics: ["sessions", "totalUsers"],
          organic: false,
        },
      },

      // ── Row 3: queries ~33% │ pages ~67% (approximating 25/75) ─
      {
        id: "GSC-top-search-queries",
        integration: "google_search_console",
        method: "search_analytics",
        metadata: {
          placement: { x: 0, y: 2, w: 2, h: 1 },
          title: "Top Search Queries",
          viewType: "pie-chart",
        },
        query: {
          dimensions: ["query"],
          rowLimit: 10,
        },
      },
      {
        id: "GSC-top-landing-pages",
        integration: "google_search_console",
        method: "search_analytics",
        metadata: {
          placement: { x: 2, y: 2, w: 4, h: 1 },
          title: "Top Landing Pages",
          viewType: "table",
        },
        query: {
          dimensions: ["page"],
          rowLimit: 10,
        },
      },

      // ── Row 4: line 100% ──────────────────────────────────────
      {
        id: "GA-content-engagement-trends-rate",
        integration: "google_analytics",
        method: "property_report",
        metadata: {
          placement: { x: 0, y: 3, w: 6, h: 1 },
          title: "Content Engagement Trends (Rate)",
          viewType: "line-chart",
        },
        query: {
          dimensions: ["date"],
          metrics: ["engagementRate"],
          orderBys: [
            {
              dimension: { dimensionName: "date" },
              desc: false,
            },
          ],
          organic: false,
        },
      },
    ] satisfies DecodedWidgetConfig[],
  },
};
